export class CopiedFromObjectLink {
  opdrachtId: string;
  copyFromId: string;

  constructor(opdrachtId: string, copyFromId: string) {
    this.opdrachtId = opdrachtId;
    this.copyFromId = copyFromId;
  }
}
